<template>
  <div class="flex flex-col">
    <!-- 3 column wrapper -->
    <div class="w-full lg:flex">
      <div class="flex-auto mb-4 mr-4 ">
        <date-time-picker :range="range" class="mb-2 w-96" />
        <div
          class="flex-shrink-0 w-full md:w-96 xl:w-96 lg:w-96 border border-gray-200"
        >
          <div class="flex items-center justify-between">
            <side-panel :root="'device'" class="w-96" />
          </div>
        </div>
      </div>

      <div class="grid grid-cols-1 w-full gap-0">
        <div class="inline-flex pt-1">
          <div class="flex w-full justify-start">
            <span class="inline-flex rounded-md">
              <button
                v-if="buttonListForShow.changeProduct === 'undefined' ? false : buttonListForShow.changeProduct"
                type="button"
                @click="toggleChangeProduct"
                class="inline-flex items-center px-4 py-3 h-8 border border-gray-300 shadow-sm text-xs leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                {{ $t('message.production.nuevaasignacion') }}
              </button>

              <button
                v-if="buttonListForShow.deleteAssign === 'undefined' ? false : buttonListForShow.deleteAssign"
                type="button"
                @click="toggleDeleteAssign"
                class="ml-2 inline-flex items-center px-4 py-3 h-8 border border-gray-300 shadow-sm text-xs leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                {{ $t('message.production.eliminarasignacion') }}
              </button>

              <button
                v-if="buttonListForShow.notification === 'undefined' ? false : buttonListForShow.notification"
                type="button"
                @click="toggleNotification"
                class="ml-2 inline-flex items-center px-4 py-3 h-8 border border-gray-300 shadow-sm text-xs leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                {{ $t('message.production.notificar') }}
              </button>

              <button
                v-if="buttonListForShow.downloadExcel === 'undefined' ? false : buttonListForShow.downloadExcel"
                type="button"
                @click="downloadExcel"
                class="ml-2 inline-flex items-center px-4 py-3 h-8 border border-gray-300 shadow-sm text-xs leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                <svg
                  v-if="downloading"
                  class="animate-spin -ml-1 mr-3 h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                  ></circle>
                  <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                {{ $t('message.production.descargarexcel') }}
              </button>
            </span>
          </div>

          <div class="ml-2 inline-flex w-full justify-end pb-3">
            <div class="relative rounded-md shadow-sm h-8 items-center">
              <input
                id="search"
                v-model="searchinput"
                class="items-center focus:ring-indigo-500 focus:border-indigo-500 block w-full h-full pl-3 pr-12 sm:text-sm border-gray-300 rounded-md"
                placeholder="Buscar"
                size="29"
              />
              <div
                class="absolute inset-y-0 right-0 flex items-center bg-white z-10 border-l-2"
              >
                <select
                  v-model="searchtype"
                  @change="onFilterChange($event)"
                  class="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-transparent bg-transparent text-gray-500 sm:text-sm rounded-md"
                >
                  <option
                    v-for="(header, index) in headersfilter"
                    :key="index"
                    :value="header.key"
                  >
                    {{ header.title }}
                  </option>
                </select>
              </div>
            </div>
            <span class="inline-flex rounded-md">
              <button
                v-if="!searching"
                @click="onSearch"
                type="button"
                class="ml-2 inline-flex items-center px-4 py-3 h-8 border border-gray-300 shadow-sm text-xs leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                <svg
                  class="-ml-0.5 mr-2 h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
                {{ $t('message.production.buscar') }}
              </button>
              <button
                v-else
                @click="onSearchReset"
                type="button"
                class="ml-2 inline-flex items-center px-4 py-3 h-8 border border-gray-300 shadow-sm text-xs leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                <svg
                  class="-ml-0.5 mr-2 h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"
                  />
                </svg>
                {{ $t('message.production.limpiar') }}
              </button>
            </span>
          </div>
        </div>

        <data-table
          v-on:select-item="
            item => {
              selectItem(item);
            }
          "
          v-on:item-dblclick="
            row => {
              openLowFlowModal(row);
            }
          "
          :headers="headers"
          :rows="rows"
          class="h-128 shadow border-b border-gray-200 sm:rounded-lg rounded-lg"
        />
      </div>
    </div>
    <alert-dialog
      v-if="deleteassignmodal"
      v-on:close-dialog="deleteassignmodal = false"
      v-on:confirm-dialog="deleteAssign"
      v-bind:title="$t('message.production.tituloeliminar')"
      :bodymsg="bodymsg"
    />
    <dynamic-form
      v-on:toggle-form="toggleNotification"
      v-if="notificationmodal"
      formtype="notification"
      :params="params"
    />
    <dynamic-form
      v-on:toggle-form="toggleBajoNominal"
      v-if="bajonominalmodal"
      formtype="bajonominal"
      :params="params"
    />
    <dynamic-form
      v-on:toggle-form="toggleChangeProduct"
      v-on:submit-form="fetchItems"
      v-if="changeproductmodal"
      formtype="changeproduct"
      :params="params"
    />
  </div>
</template>

<script>
import SidePanel from '@/components/SidePanel';
import DateTimePicker from '@/components/DateTimePicker';
import DataTable from '@/components/DataTable/DataTable';
import DynamicForm from '@/components/DynamicForm/DynamicForm';
import AlertDialog from '@/components/AlertDialog';
import axios from 'axios';
import { getUnixTime } from 'date-fns';

export default {
  name: 'production',
  components: {
    SidePanel,
    DateTimePicker,
    DataTable,
    DynamicForm,
    AlertDialog
  },
  data() {
    return {
      assigns: [],
      rows: [],
      headers: [],
      headersfilter: [],
      searching: false,
      selectedassign: null,
      notificationmodal: false,
      deleteassignmodal: false,
      bajonominalmodal: false,
      changeproductmodal: false,
      params: {},
      downloading: false,
      searchinput: '',
      search: '',
      searchtype: '',
      buttonListForShow: {}
    };
  },
  created() {
    this.fetchCustomization();
    this.fetchItems();
  },
  computed: {
    currentDevice() {
      return this.$store.getters.currentDevice;
    },
    range() {
      return {
        start: this.$store.getters.innerStart,
        end: this.$store.getters.innerEnd
      };
    },
    tsRange() {
      let tstart = this.$store.getters.innerStart;
      let tend = this.$store.getters.innerEnd;
      tstart = Math.floor(tstart.getTime() / 1000).toString();
      tend = Math.floor(tend.getTime() / 1000).toString();
      return { start: tstart, end: tend };
    },
    bodymsg() {
      var bodymsg = `${this.$i18n.t('message.production.titulomodal')} ${this.selectedassign.lote} - ${this.selectedassign.product}?`;
      return bodymsg;
    }
  },
  methods: {
    async fetchCustomization(){
      const buttons = await this.$http.get('/flow/custom/buttons_productions')
      console.log("buttons", buttons);
      this.buttonListForShow = buttons.data
    },
    async fetchItems() {
      this.selectedassign = null;
      let start = getUnixTime(this.range.start);
      let end = getUnixTime(this.range.end);
      this.assigns = [];
      let response = [];
      if (this.searchtype !== '' && this.search !== '') {
        response = await this.$http.get(
          `/assigns?devid=${this.currentDevice.devid}&start=${start}&end=${end}&searchtype=${this.searchtype}&search=${this.search}&withtotals=true`
        );
      } else {
        response = await this.$http.get(
          `/assigns?devid=${this.currentDevice.devid}&start=${start}&end=${end}&withtotals=true`
        );
      }
      this.assigns = response.data.assigns;
      this.rows = response.data.assigns;
      const headers = await this.$http.get(`/tables?table=production`);
      this.headers = headers.data;
      this.searchtype = this.headers[0].key;
      this.headersfilter = this.headers.filter(header => header.filter);
    },
    selectItem(item) {
      this.params = { ...item, devid: this.currentDevice.devid };
      this.selectedassign = item;
    },
    toggleNotification() {
      this.notificationmodal = !this.notificationmodal;
    },
    toggleBajoNominal() {
      this.bajonominalmodal = !this.bajonominalmodal;
    },
    toggleChangeProduct() {
      this.params = { devid: this.currentDevice.devid };
      this.changeproductmodal = !this.changeproductmodal;
    },
    toggleDeleteAssign() {
      if (this.selectedassign != null) {
        this.deleteassignmodal = !this.deleteassignmodal;
      }
    },
    openLowFlowModal(row) {
      this.params = row;
      this.toggleBajoNominal();
    },
    async deleteAssign() {
      console.log('deleteAssign');
      console.log(JSON.parse(JSON.stringify(this.selectedassign)));
      const response = await this.$http.delete(
        `assigns/${this.selectedassign.id}`
      );
      if (response.status === 200) {
        this.fetchItems();
      }
      console.log(JSON.parse(JSON.stringify(response)));
      this.deleteassignmodal = false;
    },
    async downloadExcel() {
      this.downloading = true;
      let start = this.tsRange.start * 1000;
      let end = this.tsRange.end * 1000;
      const baseURL = process.env.VUE_APP_ROOT_CONTROLLER;
      const url = baseURL + `products/genproductionxlsx?startdate=${start}&enddate=${end}&dev=${this.currentDevice.devid}`;
      let response = await axios.get(url);
      if (response.data === 'mts-produccion.xlsx') {
        const url = baseURL + 'xlsxreports/' + response.data;
        await axios
          .get(url, { responseType: 'blob' })
          .then(response => {
            const blob = new Blob([response.data], {
              type: 'application/vnd.ms-excel'
            });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'mts-produccion.xlsx';
            link.click();
            URL.revokeObjectURL(link.href);
          })
          .catch(console.error);
      }
      else if (response.data ==='mts-produccion.pdf') {
        const url = baseURL + 'xlsxreports/' + response.data;
        await axios
          .get(url, { responseType: 'blob' })
          .then(response => {
            const blob = new Blob([response.data], {
              type: 'application/pdf'
            });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'mts-produccion.pdf';
            link.click();
            URL.revokeObjectURL(link.href);
          })
          .catch(console.error);
      }

      this.downloading = false;
    },
    async onSearch() {
      this.search = this.searchinput;
      if (!this.search) return;
      await this.fetchItems();
      this.searching = !this.searching;
    },
    async onSearchReset() {
      this.inputReset();
      await this.fetchItems();
      this.searching = !this.searching;
    },
    onFilterChange(event) {
      this.searchtype = event.target.value;
    },
    inputReset() {
      this.searchinput = '';
      this.search = '';
      this.searchtype = this.headers[0].key;
    }
  },
  watch: {
    currentDevice() {
      this.params = { devid: this.currentDevice.devid };
      this.inputReset();
      this.fetchItems();
    },
    range() {
      this.fetchItems();
    }
  }
};
</script>
